import { GET_CART_V4 } from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'

export default () => {
  const getCartV4Experiment = getExperimentOnClient(GET_CART_V4)

  if (!getCartV4Experiment.isEnabled) {
    return
  }

  void activateExperiment(GET_CART_V4)
}
